import { staticData } from '@redlink/assets/values/staticData';

export const initialState = ({
  id,
  fullname,
  username,
  pageName,
  tags = [],
  accountType,
  isPro = accountType === staticData.planType.pro,
  bio,
} = {}) => ({
  id,
  fullname,
  username,
  pageName,
  tags,
  isPro,
  bio,
  password: '',
  isEditMode: !!id,
});

export const types = {
  SET_FULLNAME: 'SET_FULLNAME',
  SET_USERNAME: 'SET_USERNAME',
  SET_PAGE_NAME: 'SET_PAGE_NAME',
  SET_TAGS: 'SET_TAGS',
  SET_IS_PRO: 'SET_IS_PRO',
  SET_BIO: 'SET_BIO',
  SET_PASSWORD: 'SET_PASSWORD',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_FULLNAME:
      return { ...state, fullname: payload };
    case types.SET_PAGE_NAME:
      return { ...state, pageName: payload };
    case types.SET_BIO:
      return { ...state, bio: payload };
    case types.SET_USERNAME:
      return { ...state, username: payload };
    case types.SET_TAGS:
      return { ...state, tags: payload };
    case types.SET_IS_PRO:
      return { ...state, isPro: payload };
    case types.SET_PASSWORD:
      return { ...state, password: payload };
    default:
      throw new Error();
  }
};
